import { render, staticRenderFns } from "./MPopupSave.vue?vue&type=template&id=4de93b56&"
import script from "./MPopupSave.vue?vue&type=script&lang=ts&"
export * from "./MPopupSave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports